<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import router from "./router/index.js"
  // import index from "./pages/index.vue";


  export default {
    name: "app",
    data() {
      return {

      }
    },
    provide() {
      //提供
      return {};
    },
    methods: {},
    router,
    render: h => h(App),
    // components: {
    //   index,
    // },
  };

</script>

<style>
  body {
    padding: 0;
    margin: 0;
  }

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue